/**
 * Build VN turn-nav order from assistant messages since the last user message.
 * Order = first appearance in that round (speech order).
 *
 * @param {Array} messages
 * @param {Array} activeCharacters - fallback roster / name lookup
 * @param {Array} [fallbackCharacters] - used when the round has no assistants yet
 * @returns {Array<{ id: string, name: string }>}
 */
export const getLatestRoundTurnCharacters = (messages, activeCharacters = [], fallbackCharacters = null) => {
    const roster = Array.isArray(activeCharacters) ? activeCharacters : [];
    const fallback = Array.isArray(fallbackCharacters) && fallbackCharacters.length > 0
        ? fallbackCharacters
        : roster;

    const normalizeChar = (c) => {
        const id = String(c?.id ?? c?.characterId ?? c?.character_id ?? '');
        if (!id) return null;
        return {
            id,
            name: String(c?.name ?? c?.characterName ?? c?.character_name ?? 'Character')
        };
    };

    const history = Array.isArray(messages) ? messages : [];
    let lastUserIndex = -1;
    for (let i = history.length - 1; i >= 0; i -= 1) {
        if (history[i]?.role === 'user') {
            lastUserIndex = i;
            break;
        }
    }

    const roundStart = lastUserIndex >= 0 ? lastUserIndex + 1 : 0;
    const seen = new Set();
    const order = [];

    for (let i = roundStart; i < history.length; i += 1) {
        const message = history[i];
        if (message?.role !== 'assistant') continue;
        const id = String(message?.characterId ?? message?.character_id ?? '');
        if (!id || seen.has(id)) continue;
        seen.add(id);

        const rosterMatch = roster.find(
            (c) => String(c?.id ?? c?.characterId ?? c?.character_id) === id
        );
        order.push({
            id,
            name: String(
                message?.characterName
                ?? message?.character_name
                ?? rosterMatch?.name
                ?? rosterMatch?.characterName
                ?? 'Character'
            )
        });
    }

    if (order.length > 0) return order;

    return fallback.map(normalizeChar).filter(Boolean);
};
